import { render, staticRenderFns } from "./ToggleBox.vue?vue&type=template&id=723a660c&scoped=true"
import script from "./ToggleBox.vue?vue&type=script&lang=js"
export * from "./ToggleBox.vue?vue&type=script&lang=js"
import style0 from "./ToggleBox.vue?vue&type=style&index=0&id=723a660c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a660c",
  null
  
)

export default component.exports